import { get, post, put, deleteRequest } from 'helpers/api';

export const LOAD_COMMENTS = 'LOAD_COMMENTS';
export function loadComments() {
  return async (dispatch, getState) => {
    dispatch(setCommentsLoading(true));

    const comments = await get(getState().deal.commentsPath);
    dispatch({
      type: LOAD_COMMENTS,
      comments,
    });
    dispatch(setCommentsLoading(false));
  };
}

export const SET_COMMENTS_LOADING = 'SET_COMMENTS_LOADING';
export function setCommentsLoading(loading) {
  return {
    type: SET_COMMENTS_LOADING,
    loading
  };
}

export const ADD_COMMENT = 'ADD_COMMENT';
export function addComment(body) {
  return async (dispatch, getState) => {
    const comment = await post(getState().deal.commentsPath, { body });
    dispatch({
      type: ADD_COMMENT,
      comment,
    });
  };
}

export const UPDATE_COMMENT = 'UPDATE_COMMENT';
export function updateComment(comment) {
  return async (dispatch) => {
    const updatedComment = await put(comment.path, comment);
    dispatch({
      type: UPDATE_COMMENT,
      comment: updatedComment,
    });
  };
}

export const DELETE_COMMENT = 'DELETE_COMMENT';
export function deleteComment(comment) {
  return async (dispatch) => {
    const deletedComment = await deleteRequest(comment.path);
    dispatch({
      type: DELETE_COMMENT,
      comment: deletedComment,
    });
  };
}
